import React from 'react'

import ParsedFormulaDisplay from './ParsedFormulaDisplay'

import errors from '../../lib/errors.js'
import parseFormula from '../../stores/parse_formula'

/*
Props:
- formula: the actual formula to be displayed (i.e. NOT a Formula object, just
  the actual formula)
- includeResult: Boolean(false) - specifies if the result should be included
- style: CSS styling
*/
class DisplayFormula extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      parsedFormula: {},
      error: null
    }
  }

  componentDidMount() {
    parseFormula(this.props.formula)
    .then((result) => {
      this.setState({parsedFormula: result.data, error: ''})
    })
    .catch((error) => {
      this.setState({error: errors.unpack(error)})
    })
  }

  render() {
    return (
      <ParsedFormulaDisplay
        style={this.props.style}
        parsedFormula={this.state.parsedFormula}
        includeResult={this.props.includeResult}
        error={this.props.error}
      />
    )
  }
}

export default DisplayFormula



// WEBPACK FOOTER //
// ./src/components/Formulas/DisplayFormula.jsx